import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__content">
          <div className="footer__col">
            <div className="footer__logo">
              <h3>TechZone</h3>
            </div>
            <p>
              Your one-stop shop for quality products at affordable prices. 
              We deliver excellence with every purchase.
            </p>
            <div className="footer__social">
              <a href="https://www.facebook.com/profile.php?id=100071142716692" target="_blank" rel="noopener noreferrer" title="Facebook"><i className="fab fa-facebook-f"></i></a>
              <a href="https://www.instagram.com/_tech__zone_?igsh=MWl6aWJvbHBqcWkyYQ==" target="_blank" rel="noopener noreferrer" title="Instagram"><i className="fab fa-instagram"></i></a>
              <a href="https://wa.me/918940093414" target="_blank" rel="noopener noreferrer" title="WhatsApp 8940093414"><i className="fab fa-whatsapp"></i></a>
              <a href="https://wa.me/919597311787" target="_blank" rel="noopener noreferrer" title="WhatsApp 9597311787"><i className="fab fa-whatsapp"></i></a>
            </div>
          </div>

          <div className="footer__col">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/shop">Shop</Link></li>
              <li><Link to="/cart">Shopping Cart</Link></li>
              <li><Link to="/wishlist">Wishlist</Link></li>
              <li><Link to="/orders">Track Order</Link></li>
            </ul>
          </div>

          <div className="footer__col">
            <h4>Customer Service</h4>
            <ul>
              <li><Link to="/contact-us">Contact Us</Link></li>
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
              <li><Link to="/terms-and-conditions">Terms & Conditions</Link></li>
              <li><Link to="/refund-policy">Refund Policy</Link></li>
              <li><Link to="/shipping-policy">Shipping Policy</Link></li>
            </ul>
          </div>

          <div className="footer__col">
            <h4>Contact Us</h4>
            <ul>
              <li>
                <i className="fa fa-phone"></i>
                <a href="tel:8940093414">8940093414</a> (Support)
              </li>
              <li>
                <i className="fa fa-phone"></i>
                <a href="tel:9597311787">9597311787</a> (Support)
              </li>
              <li>
                <i className="fab fa-whatsapp"></i>
                <a href="https://wa.me/918940093414" target="_blank" rel="noopener noreferrer">WhatsApp: 8940093414</a>
              </li>
              <li>
                <i className="fab fa-whatsapp"></i>
                <a href="https://wa.me/919597311787" target="_blank" rel="noopener noreferrer">WhatsApp: 9597311787</a>
              </li>
              <li>
                <i className="fab fa-instagram"></i>
                <a href="https://www.instagram.com/_tech__zone_?igsh=MWl6aWJvbHBqcWkyYQ==" target="_blank" rel="noopener noreferrer">Instagram</a>
              </li>
              <li>
                <i className="fab fa-facebook-f"></i>
                <a href="https://www.facebook.com/profile.php?id=100071142716692" target="_blank" rel="noopener noreferrer">Facebook</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer__bottom">
          <div className="footer__copyright">
            <p>&copy; {new Date().getFullYear()} TechZone. All rights reserved.</p>
          </div>
          <div className="footer__payment">
            <img src="/img/payment-item.png" alt="Payment methods" loading="lazy" />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
